import logoAros from '@/views/components/sections/assets/socialProof/logo-aros.avif'
import logoBite from '@/views/components/sections/assets/socialProof/logo-bite.avif'
import logoHegelmann from '@/views/components/sections/assets/socialProof/logo-hegelmann.avif'

const DEFAULT_LOGO_HEIGHT = '1.75rem'
const DEFAULT_LOGO_HEIGHT_MD = '2rem'

type BaseSocialProofLogo = {
  name: string
  src: string
  height?: string
  heightMd?: string
}

const baseSocialProofLogos: BaseSocialProofLogo[] = [
  // {
  //   name: 'Aros Marine',
  //   src: logoAros,
  //   height: '4rem',
  // },
  {
    name: 'Bite Lietuva',
    src: logoBite,
  },
  {
    name: 'Hegelmann Group',
    src: logoHegelmann,
    height: '4rem',
  },
]

export type SocialProofLogoOptions = {
  /**
   * Height applied to the logo on small screens (any valid CSS size, e.g. `2rem` or `32px`)
   */
  height?: string
  /**
   * Height applied from the medium breakpoint upward. Falls back to `height` if omitted.
   */
  heightMd?: string
}

export type SocialProofLogo = BaseSocialProofLogo & {
  height: string
  heightMd: string
}

export const createSocialProofLogos = (
  options: SocialProofLogoOptions = {},
): SocialProofLogo[] => {
  const height = options.height ?? DEFAULT_LOGO_HEIGHT
  const heightMd =
    options.heightMd ??
    (options.height ? options.height : DEFAULT_LOGO_HEIGHT_MD)

  return baseSocialProofLogos.map((logo) => ({
    ...logo,
    height: logo.height ?? height,
    heightMd: logo.heightMd ?? heightMd,
  }))
}

export const socialProofLogos = createSocialProofLogos()
